import { STORE_SERVICES } from '../../../../../views/phone-answering/constants';

export default {
  title: 'Dienstleistungen',
  options: {
    [STORE_SERVICES.CATERING]: 'Catering',
    [STORE_SERVICES.TERRACE]: 'Terrasse vorhanden',
    [STORE_SERVICES.DINE_IN]: 'Vor-Ort-Verzehr',
    [STORE_SERVICES.ONLINE_ORDERING]: 'Online-Bestellung über FoodAmigos',
    [STORE_SERVICES.RESERVATION]: 'Reservierungen über FoodAmigos',
    [STORE_SERVICES.INTERNAL_RESERVATION]: 'Reservierungen im Restaurant',
  },
  labels: {
    reservation_total_seats: 'Gesamtzahl der reservierten Plätze',
    catering_min_people: 'Mindestanzahl Personen für Catering',
  },
};
